import is_true from "./is_true";

function getChargeUnitDisplay(unit, yearly = false){
    let unit_display = (is_true(yearly)) ?  "€/Jahr" : "€/Monat";

    if (unit === "CT_PER_KWH") unit_display = "ct/kWh";
    return unit_display;
}

export default getChargeUnitDisplay;